import { Outlet } from "react-router-dom";
import { DialerPopup } from "@/components/dialer/DialerPopup";
import { PhoneBootstrap } from "@/features/phone";
import { ChatSocketBootstrap } from "@/features/messages/components/ChatSocketBootstrap";
import { FloatingRail } from "./FloatingRail";

export function DashboardShell() {
  return (
    <div className="flex h-svh overflow-hidden bg-bg text-fg">
      <PhoneBootstrap />
      <ChatSocketBootstrap />
      <FloatingRail />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-2 pl-0 sm:p-3 sm:pl-1">
        <Outlet />
      </div>
      <DialerPopup />
    </div>
  );
}
